/* tslint:disable */
/* eslint-disable */
/**
 * BIM Data Downloader API
 * Provides a localized JavaScript snippet for the BIM catalog download modal and an endpoint to check localized Revit file availability.
 *
 * The version of the OpenAPI document:
 * Contact: info@ekkodale.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export * from "./api"
export * from "./configuration"
